/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetWorkspacesResponse } from '../../models/get-workspaces-response';

export interface GetWorkspaces$Params {
}

export function getWorkspaces(http: HttpClient, rootUrl: string, params?: GetWorkspaces$Params, context?: HttpContext): Observable<StrictHttpResponse<GetWorkspacesResponse>> {
  const rb = new RequestBuilder(rootUrl, getWorkspaces.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetWorkspacesResponse>;
    })
  );
}

getWorkspaces.PATH = '/workspaces';
